module.exports = __webpack_public_path__ + "img/feature.38007be0.jpg";